import {
  TooltipProps,
  TooltipStylesNames,
  TooltipStylesParams,
} from '@mantine/core';

import { ThemeComponentOverrides } from '../common-types';

export const Tooltip: ThemeComponentOverrides<
  TooltipProps,
  TooltipStylesNames,
  TooltipStylesParams
> = {
  defaultProps: {
    withinPortal: true,
  },
};
